import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { BlogDesktop } from "../components/Blog/BlogDesktop";
import { BlogMobile } from "../components/Blog/BlogMobile";
import { useParams } from "react-router-dom";
import { useGetBlogByTitleMutation } from "../store/Apis/UserApi";

export type Blog = { title: string; imgSrc: string; content: string; slug: string ; _id: string };

export function BlogPage() {
  const { t } = useTranslation();
  const { blogId } = useParams();
  const [getBlogByTitle] = useGetBlogByTitleMutation();
  const [selected, setSelected] = useState(null! as Blog);
  
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useEffect(() => {
    if(blogId)
    {
      getBlogByTitle({title:blogId}).unwrap().then((res)=>{
        if(res?.success)
          setSelected(res.data)
      }
      ).catch((err)=>{
        console.log("blog",err)
      })
    }
    else
      setSelected(null! as Blog)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blogId]);
  
  return (
    <Suspense>
      <Helmet>
        <link rel="canonical" href={`https://${process.env.REACT_APP_DOMAIN_NAME}/blog`} />
        <title>{t("helmet.blog_title")}</title>
        <meta
          name="description"
          content={
            t("helmet.blog_desc") || "Propaganda is an online funny board game"
          }
        ></meta>
      </Helmet>
      <div className="w-full h-full overflow-hidden">
        <BlogMobile blog={selected} />
        <BlogDesktop blog={selected} />
      </div>
    </Suspense>
  );
}
